import { render, staticRenderFns } from "./CompusList.vue?vue&type=template&id=05d67001&scoped=true"
import script from "./CompusList.vue?vue&type=script&lang=js"
export * from "./CompusList.vue?vue&type=script&lang=js"
import style0 from "./CompusList.vue?vue&type=style&index=0&id=05d67001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d67001",
  null
  
)

export default component.exports